import { PDF_FILE_EXTENSION } from '../constants';
import type { DocumentV1 } from '../types';

export const isDocumentPdfFile = (document: DocumentV1) =>
    !document.isFolder && document.content[0]?.ext === PDF_FILE_EXTENSION;
